import React from "react";
import { Container, Col, Row, Image } from "react-bootstrap";
import { Helmet } from "react-helmet";
const ReferAfriendProgm = () => {
  return (
    <>
     <Helmet>
          <meta charSet="utf-8" />
          <title>Refer A Friend</title>
        </Helmet>
      <div className="cbr_referbanner">
        <Container>
          <Row>
            <Col lg={8} className="text-center m-auto">
              <div className="cbr_refer_titel">
                <h1 className="text-white">Refer A Friend</h1>
                <p>
                  A referral is our biggest compliment – and to thank you for
                  recommending us to a friend, we’d like to give you a little
                  something.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <section className="cbr_refer_a_friend">
        <Container className="cb_footer_container">
          <Row>
            <Col md={12} lg={12} sm={12}>
              <div className="cbr_friend">
                <div className="cbr_refereal">
                  <h5>Refer A Friend</h5>
                  <p>
                    A referral is our biggest compliment – and to thank you for
                    recommending us to a friend, we’d like to give you a little
                    something.
                  </p>
                  <p>
                    When your friend completes his purchase, you will receive an
                    email with a link to redeem a $25 Amazon Gift Card!
                  </p>
                  <p>
                    You can earn a gift card each time you refer a new friend
                    who makes a purchase, no limit on your referrals!
                  </p>
                  <p>
                    We sincerely thank you for participating in this program – a
                    friend of yours is a friend of Cultured Brilliance!
                  </p>
                  <p>Best wishes,</p>
                  <p>Tony and Kathleen</p>
                  <br></br>
                  <p> The Fine Print:</p>
                  <p>
                    Limit one referral per friend. (An individual may only be
                    referred once.)
                  </p>
                  <p>
                    Referral awards are only intended for the referrer
                    individual.
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default ReferAfriendProgm;
